import UpdateRetailPrescription from "../../../../components/@documents/retail_prescriptions/UpdateRetailPrescription";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailPrescriptionUpdatePage() {

    return (
        <UpdateRetailPrescription 
            routeType={routeTypes.retail}
        />
    )
}